<template lang="pug">
  #main-header
    template(v-if="showMinimalHeader")
      app-minimal-header
    template(v-else)
      .header-logo
        a(v-if="logo" :href="logoLink", target='_blank', alt='Eurobits Home')
          img.logo(:src="logo | staticPath" alt="Logo")
      .header-nav
        header-upper-navbar
        header-lower-navbar(@refresh="$emit('refresh')")
</template>

<script>
import config from '@/utils/config'
import HeaderLowerNavbar from './HeaderLowerNavbar'
import HeaderUpperNavbar from './HeaderUpperNavbar'
import AppMinimalHeader from './MinimalHeader'

export default {
  name: 'Header',
  components: {
    HeaderLowerNavbar,
    HeaderUpperNavbar,
    AppMinimalHeader
  },
  computed: {
    logo: {
      get () {
        if (config.logoHeader) return `/static/img/${config.logoHeader}`
        return `/static/img/${config.logo}`
      }
    },
    logoLink: {
      get () {
        return config.logoLink
      }
    },
    showMinimalHeader: {
      get () {
        return this.$store.state.app.showMinimalHeader
      }
    }
  }
}
</script>
